export function obterLinkParaSkills(skills) {
  const skillsDaUrl = skills.map(skill => `${skill.id}-3`).join(",")
  return `${process.env.GATSBY_SITE_URL}/contrate-squads/${skillsDaUrl ? `squad?skills=${skillsDaUrl}` : ""
    }`
}
